import {json} from '../core/data-source/json.mapper';

export class ErrorRecord {
    @json({
        value: '',
        mapper: {from: (val: any, json: any): string => json.code || json.message || ''}
    })
    message: string;
}
